import { TasksTabs } from "../constants/tasksTabs";
import { useClosedTasksFilters } from "./useClosedTasksFilters";
import { useCompletedTasksFilters } from "./useCompletedTasksFilters";
import { useInProgressTasksFilters } from "./useInProgressTasksFilters";
import { useOpenTasksFilters } from "./useOpenTasksFilters";
import { useUpcomingTasksFilters } from "./useUpcomingTasksFilters";
import { useTranslation } from "@coworker/locales";

export type TaskTabFilters = ReturnType<
  | typeof useOpenTasksFilters
  | typeof useInProgressTasksFilters
  | typeof useCompletedTasksFilters
  | typeof useClosedTasksFilters
  | typeof useUpcomingTasksFilters
>;

export type TasksOverviewTabType = {
  key: TasksTabs;
  title: string;
  filters: TaskTabFilters;
};

export const useTasksOverviewTabs = () => {
  const { t } = useTranslation();

  const openFilters = useOpenTasksFilters();
  const inProgressFilters = useInProgressTasksFilters();
  const completedFilters = useCompletedTasksFilters();
  const closedFilters = useClosedTasksFilters();
  const upcomingFilters = useUpcomingTasksFilters();

  const taskTabs: TasksOverviewTabType[] = [
    {
      key: TasksTabs.OPEN,
      title: t("teamOpenString"),
      filters: openFilters,
    },
    {
      key: TasksTabs.IN_PROGRESS,
      title: t("inProgressString"),
      filters: inProgressFilters,
    },
    {
      key: TasksTabs.UPCOMING,
      title: t("upcomingString"),
      filters: upcomingFilters,
    },
    {
      key: TasksTabs.COMPLETED,
      title: t("completd3String"),
      filters: completedFilters,
    },
    {
      key: TasksTabs.CLOSED,
      title: t("teamClosedString"),
      filters: closedFilters,
    },
  ];

  return taskTabs;
};
